/** Leaf module: shared by the linter and the host-fallback writer, which would otherwise import each other. */

/** Source with every `#ifdef SHADYGRAM_HOST … #endif` block removed: what another host compiles. */
export function withoutHostGuards(body: string): string {
  const lines = body.split('\n');
  const kept: string[] = [];
  let depth = 0;
  for (const line of lines) {
    const trimmed = line.trim();
    if (/^#if(n?def)?\s+SHADYGRAM_HOST\b|^#if\s+defined\s*\(\s*SHADYGRAM_HOST\s*\)/.test(trimmed)) {
      depth += 1;
      continue;
    }
    if (depth > 0) {
      if (/^#endif\b/.test(trimmed)) depth -= 1;
      else if (/^#else\b|^#elif\b/.test(trimmed)) { /* the other host's branch: keep it */ depth -= 1; }
      continue;
    }
    kept.push(line);
  }
  return kept.join('\n');
}

